<template>
  <b-card no-body>
    <b-card-header v-if="title || subtitle || hasHeaderSuffix" class="header">
      <!-- <template v&#45;slot:header > -->
      <div class="d-flex flex-row align-items-center">
        <slot name="header-prefix"></slot>
        <span class="mb-0 mx-2 d-flex align-items-center">{{ title }}</span>
      </div>
      <slot name="header-suffix"></slot>
      <!-- </template> -->
    </b-card-header>

    <!-- <b&#45;row v&#45;if="!connected" align&#45;h="end"> -->
    <slot v-if="noBody"></slot>
    <b-card-body v-if="!noBody || error">
      <b-col align-h="end" class="px-0">
        <slot v-if="!noBody" class="mb-3"></slot>

        <b-alert v-show="error" show variant="warning" class="mt-3">
          <h6 v-if="errorTitle">{{ errorTitle }}</h6>
          <pre class="pre-wrap m-0">{{ error }}</pre>
        </b-alert>
      </b-col>
    </b-card-body>

    <template v-slot:footer v-if="hasFooter">
      <div class="footer">
        <slot name="footer"></slot>
      </div>
    </template>
  </b-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Card',
  components: {},
  props: {
    title: String,
    subtitle: String,
    error: String,
    noBody: {
      type: Boolean,
      default: false,
    },
    errorTitle: String,
    flexEndFooter: {
      type: Boolean,
      default: true,
    },
  },
  // created() { },
  data() {
    return {};
  },
  computed: {
    hasFooter() {
      return !!(this.$slots as any)?.footer?.length;
    },
    hasHeaderSuffix() {
      return !!(this.$slots as any)?.headerSuffix?.length;
    },
  },
  methods: {},
  watch: {},
});
</script>

<style scoped>
.footer {
  display: flex;
  justify-content: flex-end;
}
.header {
  display: flex;
  justify-content: space-between;
}
</style>
